import { taxContexts } from 'Constants/Projects/TaxContexts';

export const taxContextFilter = [
  { id: 0, name: 'All Tax Contexts' },
].concat(taxContexts);